import React, { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import { compactMessage, eventDetailRows, formatPayload } from "./logResultFormat";

function levelClass(level) {
  switch (level) {
    case "ERROR": return "bg-red-100 text-red-800";
    case "WARN": return "bg-yellow-100 text-yellow-800";
    case "INFO": return "bg-blue-100 text-blue-800";
    case "DEBUG": return "bg-gray-100 text-gray-800";
    case "TRACE": return "bg-purple-100 text-purple-800";
    default: return "bg-gray-100 text-gray-800";
  }
}

function LogResultRow({ log, formatTimestamp }) {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState("");
  const message = String(log?.message || "");
  const payload = formatPayload(message);
  const details = eventDetailRows(log);
  const service = log?.service || log?.application || "";

  const copyText = async (label, text) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(label);
    } catch {
      setCopied("Copy failed");
    }
  };

  return (
    <article className="log-event-card">
      <button
        type="button"
        className="log-event"
        aria-expanded={open}
        onClick={() => setOpen((value) => !value)}
      >
        {open ? <ChevronDown size={14} aria-hidden="true" /> : <ChevronRight size={14} aria-hidden="true" />}
        <span className="log-event-time">{formatTimestamp(log?.timestamp)}</span>
        <span className={`log-event-level ${levelClass(log?.level)}`}>{log?.level || ""}</span>
        <span className="log-event-service">{service}</span>
        <span className="log-event-message" title={message}>{compactMessage(message)}</span>
        {log?.traceId ? <span className="log-event-trace">{log.traceId}</span> : null}
      </button>
      {open && (
        <div className="log-event-details">
          <div className="log-event-detail-actions">
            <button type="button" onClick={() => copyText("message", message)}>Copy message</button>
            <button
              type="button"
              onClick={() => copyText("event", `${details.map((row) => `${row.label}: ${row.value}`).join("\n")}\nMessage:\n${message}`)}
            >
              Copy details
            </button>
            {copied && <span role="status">{copied === "Copy failed" ? copied : `Copied ${copied}`}</span>}
          </div>
          <dl>
            {details.map((row) => (
              <div key={row.label}>
                <dt>{row.label}</dt>
                <dd>{row.value}</dd>
              </div>
            ))}
          </dl>
          <h4>Message</h4>
          <pre>{payload.text || message}</pre>
        </div>
      )}
    </article>
  );
}

export default function LogResultList({ logs, formatTimestamp }) {
  return (
    <div className="log-event-list">
      {(logs || []).map((log, index) => (
        <LogResultRow
          key={log?.id || `${log?.timestamp || "log"}-${index}`}
          log={log}
          formatTimestamp={formatTimestamp}
        />
      ))}
    </div>
  );
}
